import { useQuery } from '@tanstack/react-query'
import { getProductsUpsales } from '~/lib/get-products-upsales'

import { useGetCart } from '@unlikelystudio/react-ecommerce-hooks'

import { useGlobalData } from '~/providers/GlobalDataProvider'

import useLocale from '~/hooks/useLocale'

export function useGetProductsUpsales(ids, withDefault = true) {
  const locale = useLocale()
  const {
    global: { upsales: globalUpsales },
  } = useGlobalData()
  const { data: cartData } = useGetCart({ refetchOnMount: false })
  const lineItemsIds = cartData?.lines?.map(
    (line) => line?.merchandise?.product?.id,
  )
  const { refetch, ...rest } = useQuery([ids, lineItemsIds], async () => {
    try {
      const filteredGlobalUpsales = withDefault
        ? globalUpsales?.filter((item) => ids?.indexOf(item?.shopifyId) === -1)
        : []
      const productsUpsales = (
        (await getProductsUpsales(ids, locale)) ?? []
      )?.filter((item) => ids?.indexOf(item?.shopifyId) === -1)

      const filteredItems =
        productsUpsales?.filter(
          (upsale) => lineItemsIds?.indexOf(upsale?.shopifyId) === -1,
        ) ?? []

      return productsUpsales?.length > 0 ? filteredItems : filteredGlobalUpsales
    } catch (error) {
      throw new Error(error)
    }
  })

  return { ...rest }
}
